import { Component, HostListener, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ProgressBarDataService } from './progress-bar.service';
import { WorkflowPageNavigationStateService } from '../../../service/workflow-page-navigation-state/workflow-page-navigation-state.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'cu-workflow-progress',
  templateUrl: './workflow-progress.component.html',
  styleUrls: ['./workflow-progress.component.scss']
})
export class WorkflowProgressComponent implements OnInit, OnDestroy {
  @Input() public title: string;
  // Progress percentage
  @Input() public progress = 0;
  // TODO: UX - can this be used to contain the page subtext? If not, can this be removed?
  @Input() public footer: string;

  // TODO: deprecate all the below inputs?
  @Input() public completed: number;
  @Input() public total: number;
  @Input() public separator: string;
  @Input() public completedText: string;
  @Input() public flowType: 'OAO' | 'OLA';
  public productDetailsExpanded = false;
  public progressPercent = 0;
  public productIcon: string;

  @ViewChild('loanDetailsAccordion') loanDetailsAccordion;

  private subscription: Subscription;

  constructor(
    public readonly progressBarData: ProgressBarDataService,
    private readonly pageStateService: WorkflowPageNavigationStateService
  ) {}
  public ngOnDestroy(): void {
    this.subscription && this.subscription.unsubscribe();
  }

  public ngOnInit(): void {
    this.progressBarData.setStateFulValues();
    this.progressBarData.flowType = this.flowType;
    this.progressBarData.SetLoanGroupDisplayName();
    this.setupChart();

    /** since page state used to calculate progress.
     * isStateRetrved flag helps to recalculate the progress once state retrived   */
    if (this.progress <= 0)
      this.subscription = this.pageStateService.navigationStateRetrieved$.subscribe((s) => {
        if (s) {
          // timeout helps to calculate percentage on page refresh
          setTimeout(() => {
            this.setupChart();
            this.progressPercent = this.progressBarData.CalculatePercentage(this.progress);
          }, 300);

          this.subscription && this.subscription.unsubscribe();
        }
      });
  }

  private setupChart() {
    this.updateChurroChart();
    this.progressPercent = this.progressBarData.CalculatePercentage(this.progress);
  }

  /**
   * Updates the visualization for the churro chart to reflect the current progress.
   *
   * This method calculates the width of the SVG representing the churro chart,
   * based on the current value of `progress` input. The changes are then applied to the DOM
   * after a short delay, to ensure it's rendered properly.
   *
   * Note: Uses `setTimeout` to account for potential DOM rendering delays. If any structural changes
   * are made to the way the component is rendered (e.g., changes to `ngIf` conditions),
   * you might need to adjust or remove this delay.
   */
  public updateChurroChart(): void {
    // set timeout to allow DOM to render (remove if ngif is removed)
    setTimeout(() => {
      const element: HTMLElement = document.getElementById('churro-progress');
      // const percent: number = !this.completed || this.completed === 0 ? 0 : this.completed / this.total;
      // Calculate and set progress width
      const width = this.progressPercent.toString() + '%';
      element?.setAttribute('width', width);
    }, 100);
  }

  /**
   * Get application completion percentage
   */
  public get completionPercent() {
    return Math.round(this.progressPercent).toString() + '%';
  }

  /**
   * Method to toggle accordion
   * @param loanDetailsAccordion
   */
  public toggleLoanDetailsAccordion(loanDetailsAccordion) {
    if (!this.progressBarData.isDataAvailable) return;
    this.productDetailsExpanded = !this.productDetailsExpanded;
    loanDetailsAccordion.toggle();
  }

  @HostListener('document:click', ['$event'])
  outsideClick(event): void {
    const progressDetailsToggle = document.getElementById('progress-product-detail-toggle');
    if (progressDetailsToggle && !progressDetailsToggle.contains(event.target) && this.loanDetailsAccordion.isOpen) {
      this.productDetailsExpanded = !this.productDetailsExpanded;
      this.loanDetailsAccordion.toggle();
    }
  }
}
